var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"row -align-start map-filters"},[_c('FilterRadio',_vm._b({},'FilterRadio',_vm.category,false)),_c('FilterRadio',_vm._b({attrs:{"has-icon":true}},'FilterRadio',_vm.owner,false)),_c('FilterRadio',_vm._b({},'FilterRadio',_vm.status,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }